import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { CiEdit } from 'react-icons/ci';
import { MdDelete } from "react-icons/md";
import { FaUserLock } from "react-icons/fa";
import { Button, Pagination } from '@mui/material';
import { json, useNavigate } from 'react-router-dom';
import ViewAllEmployees from '../../../component/b2c/models/ViewAllEmployee';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../css/custom-scrollbar.css';
import { HiUsers } from "react-icons/hi";
import { toast } from 'react-toastify';
import { Base_Url, AllEmployeeList,deleteEpmloyee } from '../../../config/config';
import SetPermission from '../../../component/b2c/models/setPermissionModel';

const AllEmployee = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode } = useMyContext();
  const [isPopupOpenPermission, setIsPopupOpenPermission] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { isToggleSidebar } = useMyContext();
  const [employee, setEmployee] = useState([]);
  const [empLoyeePermission, setEmployeePermission] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const itemsPerPage = 8;

  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10); 

  useEffect(() => {
    fetchWarehouses();
  }, [page, limit,setEmployee]); 


  const fetchWarehouses = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const pageNumber = Number(page) || 1;
      const limitNumber = Number(limit) || 10;
      const url_for_allEmployee = `${Base_Url}${AllEmployeeList}?page=${pageNumber}&limit=${limitNumber}`
      const response = await fetch(url_for_allEmployee, {
        method: 'GET',
        headers: {
        'token': token,
            'cus_id': cusid,
            'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "SUCCESS") {
        setEmployee(result.data);
        setTotalOrders(result.pagination.totalItems || 0);
      } else {
      }
    } catch (error) {
    }
  };


  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  

  const handleViewClick = (employee) => {
    setSelectedEmployee(employee);
    setIsPopupOpen(true);
  };


  const handleClose = () => {
    setIsPopupOpen(false);
  };


  const handleViewPermissionPopup =(employee) =>{
    setIsPopupOpenPermission(true);
    setEmployeePermission(employee);

  }

  const handleClosePermissionPopup = () => {
    setIsPopupOpenPermission(false);
  };


  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const handleDelete = async (id) => {
    const urldelete = Base_Url + deleteEpmloyee;
  
    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');
  
      const response = await fetch(`${urldelete}/${id}`, {
        method: 'GET', 
        headers: {
          token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });
  
      const data = await response.json();
  
      if (data.status === "success") {
        setEmployee((prevWarehouses) => prevWarehouses.filter(employee => employee.id !== id));
        toast.success(data.message);
        setTotalOrders((prev) => prev - 1);
        fetchWarehouses();
    
      } else {
        toast.error( data.message);
      }
  
    } catch (error) {
      toast.error( error.message);
    }
  };

  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'bg-black' : 'bg-white'}`}>
        <div className="z-10">
          <NavBar />
        </div>

        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-white dark:bg-black md:bg-transparent mt-4 md:w-64 md:z-20 border-r border-gray-200 dark:border-gray-800`}
            style={
              window.innerWidth < 768 
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
              <Sidebar />
            </div>
          )}

          <div className={`overflow-x-hidden  w-full  overflow-y-auto p-5 border ${isDarkMode ? 'bg-gray-100 border-gray-800 text-white' : 'bg-white border-gray-200 text-black'}`}>

            {/* Header */}
            <div className={`flex items-center gap-3 mb-6 pb-4 border-b ${isDarkMode ? 'border-gray-800' : 'border-gray-200'}`}>
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${isDarkMode ? 'bg-white text-black' : 'bg-black text-white'}`}>
                <HiUsers size={20} />
              </div>
              <div>
                <h1 className="text-lg sm:text-xl font-bold tracking-tight">All Employees</h1>
                <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Manage your team members and permissions</p>
              </div>
            </div>

            {/* Table */}
            <div className={`overflow-x-auto rounded-xl border ${isDarkMode ? 'border-gray-800' : 'border-gray-200'}`}>
              <table className="min-w-full w-full border-collapse table-auto text-sm">
                <thead>
                  <tr className={`${isDarkMode ? 'bg-white text-black' : 'bg-slate-800 text-white'} text-xs uppercase tracking-wide`}>
                    <th className="p-3 text-left w-1/12 font-semibold">Id</th>
                    <th className="p-3 text-left w-2/12 font-semibold">Name</th>
                    <th className="p-3 text-left w-3/12 font-semibold">Email</th>
                    <th className="p-3 text-left w-2/12 font-semibold">Phone</th>
                    <th className="p-3 text-left w-2/12 font-semibold">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {employee.reverse().map((employee, index) => (
                    <tr
                      key={employee.id}
                      className={`w-full border-t ${isDarkMode ? 'border-gray-800' : 'border-gray-200'} ${
                        index % 2 === 0
                          ? (isDarkMode ? 'bg-black' : 'bg-white')
                          : (isDarkMode ? 'bg-gray-900/40' : 'bg-gray-50')
                      } hover:${isDarkMode ? 'bg-gray-800/60' : 'bg-gray-100'} transition-colors`}
                    >
                      <td className={`p-3 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>{employee.id}</td>
                      <td className="p-3 font-medium">{employee.name}</td>
                      <td className={`p-3 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>{employee.email}</td>
                      <td className={`p-3 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>{employee.phone}</td>
                      <td className="p-3">
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => handleViewClick(employee)}
                            title="View"
                            className={`w-8 h-8 flex items-center justify-center rounded-lg border transition-colors ${isDarkMode ? 'border-gray-700 text-white hover:bg-white hover:text-black' : 'border-gray-300 text-black hover:bg-black hover:text-white'}`}
                          >
                            <IoMdEye size={15} />
                          </button>
                          <button
                            title="Edit"
                            className={`w-8 h-8 flex items-center justify-center rounded-lg border transition-colors ${isDarkMode ? 'border-gray-700 text-white hover:bg-white hover:text-black' : 'border-gray-300 text-black hover:bg-black hover:text-white'}`}
                          >
                            <CiEdit size={15} />
                          </button>
                          <button
                            onClick={() => handleDelete(employee.employee_id)}
                            title="Delete"
                            className={`w-8 h-8 flex items-center justify-center rounded-lg border transition-colors ${isDarkMode ? 'border-gray-700 text-white hover:bg-white hover:text-black' : 'border-gray-300 text-black hover:bg-black hover:text-white'}`}
                          >
                            <MdDelete size={15} />
                          </button>
                          <button
                            onClick={() => handleViewPermissionPopup(employee)}
                            title="Permissions"
                            className={`w-8 h-8 flex items-center justify-center rounded-lg border transition-colors ${isDarkMode ? 'border-gray-700 text-white hover:bg-white hover:text-black' : 'border-gray-300 text-black hover:bg-black hover:text-white'}`}
                          >
                            <FaUserLock size={14} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Footer / Pagination */}
            <div className="mt-5 flex flex-col sm:flex-row justify-between items-center gap-3">
              <span className={`text-xs font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                {`Total Employees: ${totalOrders}`}
              </span>

              <select
                id="limit"
                value={limit}
                onChange={handleLimitChange}
                className={`border rounded-lg px-3 py-1.5 text-xs focus:outline-none focus:ring-2 ${isDarkMode ? 'bg-black border-gray-700 text-white focus:ring-white/30' : 'bg-white border-gray-300 text-black focus:ring-black/20'}`}
              >
                <option value={10}>10</option>
                <option value={15}>15</option>
                {/* <option value={50}>50</option> */}
                <option value={totalOrders}>All</option>
              </select>

              <Pagination
                count={Math.ceil(totalOrders / limit)}
                page={page}
                onChange={handlePaginationChange}
                variant="outlined"
                shape="rounded"
                size="small"
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    sx={{
                      color: isDarkMode ? '#fff' : '#000',
                      borderColor: isDarkMode ? '#374151' : '#d1d5db',
                      '&.Mui-selected': {
                        backgroundColor: isDarkMode ? '#fff' : '#000',
                        color: isDarkMode ? '#000' : '#fff',
                        '&:hover': {
                          backgroundColor: isDarkMode ? '#e5e5e5' : '#1f1f1f',
                        },
                      },
                      '&:hover': {
                        backgroundColor: isDarkMode ? '#1f2937' : '#f3f4f6',
                      },
                    }}
                  />
                )}
              />
            </div>
          </div>
        </div>
        <ViewAllEmployees isopen={isPopupOpen} onClose={handleClose} employee={selectedEmployee} />
        <SetPermission isopen={isPopupOpenPermission} onClose= {handleClosePermissionPopup } selectedEmpForSetPermission={empLoyeePermission}/>
      </div>
    </>
  );
};

export default AllEmployee;